module.exports = __webpack_public_path__ + "img/月亮日記加.490f6408.svg";